import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineColoursSchema: CollectionCreateSchema = {
  name: CollectionName.WineColours,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
